/**
 * React Contexts
 * 用于项目编辑器等UI组件的上下文传递
 */
import { createContext } from "react";
import { IProject } from '../entities/IProject';
import { IActionGroup } from '../entities/IActionGroup';
import { ITriggerGroup } from '../entities/ITriggerGroup';
import { ITriggerAction } from '../entities/ITriggerAction';
import { ITriggerActionGroup } from '../entities/ITriggerActionGroup';
import { IAction } from '../entities/IAction';
import { ITrigger } from '../entities/ITrigger';
import { GroupCheckList1, GroupCheckList2 } from '../types/tree';

// === Project Context ===
export const ProjectContext = createContext<IProject>({} as IProject)

// === TriggerAction Contexts ===
export const TriggerActionGroupContext = createContext<ITriggerActionGroup>({} as ITriggerActionGroup)
export const TriggerActionContext = createContext<ITriggerAction>({} as ITriggerAction)

// === Trigger Contexts ===
export const TriggerGroupContext = createContext<ITriggerGroup>({} as ITriggerGroup)
export const TriggerListContext = createContext<ITrigger[]>([] as ITrigger[])
export const TriggerContext = createContext<ITrigger>({} as ITrigger)

// === Action Contexts ===
export const ActionGroupContext = createContext<IActionGroup>({} as IActionGroup)
export const ActionListContext = createContext<IAction[]>([] as IAction[])
export const ActionContext = createContext<IAction>({} as IAction)

// === GroupCheck Contexts ===
export const GroupCheckList1Context = createContext<GroupCheckList1>([] as GroupCheckList1)
export const GroupCheckList2Context = createContext<GroupCheckList2>([] as GroupCheckList2)
